export const item = () => ({
    width: '100%',
    marginBottom: '32px',
    ':last-child': {
        marginBottom: 0,
    },
});

export const header = () => ({
    backgroundColor: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '24px 32px',
    width: '100%',
    cursor: 'pointer',
    border: 'none',
    textAlign: 'left',
    outline: 'none',
    ':hover': {
        backgroundColor: '#f8f8f8',
    },
    ':focus': {
        outline: '2px solid #4ab48b',
        outlineOffset: '-2px',
    },
});

export const question = ({ theme }) => ({
    flex: '1 0 0',
    fontFamily: theme.fontFamily,
    fontWeight: 700,
    fontSize: '20px',
    lineHeight: '36px',
    color: theme.colors.black,
    margin: 0,
    paddingRight: '16px',
    min768px: {
        fontSize: '24px',
        lineHeight: '44px',
    },
    min992px: {
        fontSize: '28px',
        lineHeight: '50px',
    },
});

export const chevron = () => ({
    flexShrink: 0,
    width: '24px',
    height: '24px',
    transition: 'transform 0.25s ease',
});

export const chevronOpen = () => ({
    transform: 'rotate(180deg)',
});

export const answer = ({ theme }) => ({
    backgroundColor: '#ffffff',
    padding: '0 32px 32px',
    fontFamily: theme.fontFamily,
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '26px',
    color: theme.colors.black,
    opacity: 0.8,
    margin: 0,
    min768px: {
        fontSize: '18px',
        lineHeight: '28px',
    },
    min992px: {
        fontSize: '20px',
        lineHeight: '32px',
    },
});
